import { motion, useReducedMotion } from "framer-motion";

// Real official product renders (transparent PNGs in /public/phones).
const PHONES = {
  iphone: { src: "/phones/iphone.png", label: "iPhone 17 Pro Max", glow: "rgba(46,107,230,0.55)", alt: "iPhone 17 Pro Max in Cosmic Orange, back view" },
  samsung: { src: "/phones/samsung.png", label: "Galaxy S26 Ultra", glow: "rgba(139,92,255,0.55)", alt: "Samsung Galaxy S26 Ultra in Cobalt Violet, back view" },
  pixel: { src: "/phones/pixel.png", label: "Pixel 11 Pro", glow: "rgba(127,224,195,0.5)", alt: "Google Pixel 11 Pro, back view" },
};

export const phoneMeta = (variant) => PHONES[variant] || PHONES.iphone;

export const PhoneFloat = ({ variant, className = "", imgClassName = "", caption = true }) => {
  const v = phoneMeta(variant);
  return (
    <div className={`flex flex-col items-center gap-3 ${className}`}>
      <img
        src={v.src}
        alt={v.alt}
        draggable="false"
        className={`w-auto select-none ${imgClassName}`}
        style={{ filter: `drop-shadow(0 0 46px ${v.glow}) drop-shadow(0 34px 30px rgba(0,0,0,0.6))` }}
      />
      {caption && (
        <span className="whitespace-nowrap font-mono text-[10px] uppercase tracking-[0.24em] text-ink/50">
          {v.label}
        </span>
      )}
    </div>
  );
};

export const PhoneBgDrift = ({ variant, className = "" }) => {
  const v = phoneMeta(variant);
  const reduce = useReducedMotion();
  return (
    <motion.img
      src={v.src}
      alt=""
      aria-hidden="true"
      draggable="false"
      className={`pointer-events-none absolute select-none opacity-[0.15] ${className}`}
      style={{ filter: `drop-shadow(0 0 70px ${v.glow})` }}
      animate={reduce ? {} : { y: [0, -28, 0], rotate: [-4, 4, -4] }}
      transition={{ duration: 12, repeat: Infinity, ease: "easeInOut" }}
    />
  );
};
